<template>
	<material-popup :dialogShowModel="showAttachment" @escintent="closeAttachment()">
		<ValidationObserver ref="attachmentobserver" tag="div" v-slot="{ failed }">
			<material-card icon="fas fa-paperclip" :title="$t('attachment.attachments')" dismissable @dismissed="closeAttachment()">
				<v-row dense>
					<v-col cols="12" xs="12" align="right" class="py-0" v-if="!showAddAttachment">
						<v-btn @click="addNewAttachment()" small outlined>
							{{ $t("attachment.add_attachment") }}
							<v-icon small class="pl-1">fas fa-plus</v-icon>
						</v-btn>
					</v-col>
					<v-col cols="12" xs="12" v-if="showAddAttachment">
						<ValidationProvider vid="title" :name="$t('attachment.file_title')" rules="max:100" v-slot="{ errors, field }">
							<v-text-field :label="$t('attachment.file_title')" v-model="title" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-col>
					<v-col cols="12" xs="12" v-if="showAddAttachment">
						<ValidationProvider vid="description" :name="$t('attachment.file_description')" rules="max:255" v-slot="{ errors, field }">
							<v-text-field :label="$t('attachment.file_description')" v-model="description" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-col>
					<v-col cols="12" xs="12" :sm="extraInfoSize" v-for="(extrainfo, extrakey) in extra_info" :key="extrakey" v-if="showAddAttachment">
						<v-text-field :label="extrakey" v-model="extra_info[extrakey]"></v-text-field>
					</v-col>
					<v-col cols="12" xs="12" sm="6" :class="{ 'd-flex justify-end': $vuetify.breakpoint.xsOnly }" class="py-0" v-if="showAddAttachment">
						<v-checkbox v-if="canBeReaded" hide-details class="ma-0" :label="$t('attachment.readAttachmentInfoFromFile')" v-model="readAttachmentInfoFromFile">
							<info-box slot="prepend" :title="$t('attachment.readAttachmentInfoFromFile')" :message="$t('attachment.readAttachmentInfoFromFileTooltip')"></info-box>
						</v-checkbox>
					</v-col>
					<v-col cols="12" xs="12" sm="6" align="right" class="py-0" v-if="showAddAttachment">
						<v-btn @click="addExtraKey()" small outlined>
							{{ $t("attachment.extra_info") }}
							<v-icon small class="pl-1">fas fa-plus</v-icon>
						</v-btn>
					</v-col>
					<v-col cols="12" xs="12" v-if="showAddAttachment">
						<upload-file vid="attachment" :name="$t('attachment.attachment')" @fileuploaded="storeTempForUpload" :uploading="uploadattachment_loading" :types="['image', 'pdf']"></upload-file>
					</v-col>
					<v-col cols="12" xs="12" sm="6" v-if="!showAddAttachment && currentDisplayAttachment" class="pb-2">
						<v-img v-if="currentDisplayAttachment.thumbnail_link && currentAttachmentModel.id" :src="currentDisplayAttachment.thumbnail_link" contain @click="$functions.openLink(currentDisplayAttachment.link)" max-height="330" class="clickarea">
							<template v-slot:placeholder>
								<v-sheet>
									<v-skeleton-loader type="image"></v-skeleton-loader>
								</v-sheet>
							</template>
						</v-img>
						<v-card v-else outlined @click="currentAttachmentModel.id ? downloadOrViewAttachment() : null">
							<v-card-text v-intersect="loadAttachmentPreview()">
								<v-row class="d-flex flex-column" dense align="center" justify="center">
									<v-icon class="mt-5 mb-3" size="60">fas fa-hat-wizard</v-icon>
									<v-progress-linear indeterminate height="25">
										<strong>{{ $t("attachment.preview_loading") }}</strong>
									</v-progress-linear>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" xs="12" sm="6" v-if="!showAddAttachment && currentDisplayAttachment">
						<list-content-value boldtitle :contenttitle="$t('attachment.file_title')" :contentvalue="currentDisplayAttachment.title" :loading="attachment_loading"></list-content-value>
						<list-content-value boldtitle :contenttitle="$t('attachment.filename')" :contentvalue="currentDisplayAttachment.filename" :loading="attachment_loading"></list-content-value>
						<list-content-value boldtitle :contenttitle="$t('attachment.filesize')" :contentvalue="$formatters.fileSize(currentDisplayAttachment.filesize)" :loading="attachment_loading"></list-content-value>
						<list-content-value boldtitle :contenttitle="$t('attachment.file_description')" :contentvalue="currentDisplayAttachment.description" :loading="attachment_loading"></list-content-value>
						<list-content-value boldtitle v-for="(extrainfo, extrakey) in currentDisplayAttachment.extra_info" :key="extrakey" :contenttitle="extrakey" :contentvalue="extrainfo" :loading="attachment_loading"></list-content-value>
						<v-row dense>
							<v-col cols="12" xs="12" align="right">
								<action-button small color="warning" type="edit" @click="showUpdateAttachment()" outlined :text="$t('global.edit')"></action-button>
								<action-button small @click="deleteAttachment()" type="delete" outlined :text="$vuetify.breakpoint.xsOnly ? null : $t('global.delete')" :disabled="attachment_loading"></action-button>
							</v-col>
						</v-row>
						<instant-edit v-model="single_attachment_edit" icon="fas fa-paperclip" title="Modifica" v-if="showAttachment">
							<v-row justify="center" dense>
								<v-col cols="12" xs="12">
									<ValidationProvider ref="title" vid="title" :name="$t('attachment.file_title')" rules="max:100" v-slot="{ errors, field }">
										<v-text-field :label="$t('attachment.file_title')" v-model="currentAttachment.title" :error-messages="errors"></v-text-field>
									</ValidationProvider>
								</v-col>
								<v-col cols="12" xs="12" sm="12">
									<ValidationProvider ref="filename" vid="filename" :name="$t('attachment.filename')" rules="" v-slot="{ errors, field }">
										<v-text-field :label="$t('attachment.filename')" v-model="currentAttachment.filename" :error-messages="errors"></v-text-field>
									</ValidationProvider>
								</v-col>
								<v-col cols="12" xs="12">
									<ValidationProvider ref="description" vid="description" :name="$t('attachment.file_description')" rules="max:255" v-slot="{ errors, field }">
										<v-text-field :label="$t('attachment.file_description')" v-model="currentAttachment.description" :error-messages="errors"></v-text-field>
									</ValidationProvider>
								</v-col>
								<v-col cols="12" xs="12" :sm="extraInfoSize" v-for="(extrainfo, extrakey) in currentAttachment.extra_info" :key="extrakey">
									<v-text-field :label="extrakey" v-model="currentAttachment.extra_info[extrakey]"></v-text-field>
								</v-col>
								<v-col cols="12" xs="12" align="right" class="py-0">
									<v-btn @click="addExtraKey()" small outlined>
										{{ $t("attachment.extra_info") }}
										<v-icon small class="pl-1">fas fa-plus</v-icon>
									</v-btn>
								</v-col>
							</v-row>
							<template slot="instantactions">
								<v-col cols="6" xs="6" sm="4" align="right">
									<action-button large @click="single_attachment_edit = false" outlined text="Annulla"></action-button>
								</v-col>
								<v-col cols="6" xs="6" sm="4" align="right">
									<action-button large @click="updateAttachment()" color="success" text="Ok" :disabled="attachment_loading" :loading="attachment_loading"></action-button>
								</v-col>
							</template>
						</instant-edit>
					</v-col>
					<instant-edit v-model="extra_key_add" icon="fas fa-tag" :title="$t('attachment.extra_info')" @closeandupdate="addExtraInfoToCurrentAttachment">
						<v-row dense>
							<v-col cols="12" xs="12" sm="6">
								<v-text-field :label="$t('attachment.extra_key')" v-model="extra_key"></v-text-field>
							</v-col>
							<v-col cols="12" xs="12" sm="6">
								<v-text-field :label="$t('attachment.extra_value')" v-model="extra_value"></v-text-field>
							</v-col>
						</v-row>
					</instant-edit>
					<instant-edit v-model="showAttachmentProposedData" icon="fas fa-paperclip" :title="$t('attachment.readed_informations')" v-if="showAttachmentProposedData">
						<v-row justify="center" dense>
							<v-col cols="12" xs="12" sm="3" v-if="attachmentProposedData.cert_expiration != undefined">
								<date-field vid="cert_expiration" :name="$t('associates.cert_expiration_extended')" rules="date_format" v-model="attachmentProposedData.cert_expiration"></date-field>
							</v-col>
							<v-col cols="12" xs="12" class="d-flex justify-end">
								<v-checkbox hide-details :label="$t('attachment.update_info')" v-model="attachmentProposedData.update_info"></v-checkbox>
							</v-col>
						</v-row>
						<template slot="instantactions">
							<v-col cols="6" xs="6" sm="4" align="right">
								<action-button large @click="showAttachmentProposedData = false" outlined text="Annulla"></action-button>
							</v-col>
							<v-col cols="6" xs="6" sm="4" align="right">
								<action-button large @click="updateAttachmentProposedData()" color="success" text="Ok" :disabled="attachment_loading" :loading="attachment_loading"></action-button>
							</v-col>
						</template>
					</instant-edit>
				</v-row>
				<template slot="actions">
					<v-col cols="12" align="center" v-if="!showAddAttachment">
						<v-pagination v-model="current_attachment_index" :length="currentAttachmentModel.id ? currentAttachmentModel.attachments.length : temporaryAttachment.length"></v-pagination>
					</v-col>
					<v-col cols="6" xs="6" sm="3" v-if="!showAddAttachment">
						<action-button large @click="showAttachment = false" color="success" :text="'Ok'"></action-button>
					</v-col>
					<v-col cols="6" xs="6" sm="3" v-if="showAddAttachment && !uploadattachment_loading">
						<action-button large @click="closeAddAttachment()" outlined text="Annulla"></action-button>
					</v-col>
					<v-col cols="6" xs="6" sm="3" v-if="showAddAttachment">
						<action-button large @click="uploadAttachment" color="success" :text="'Upload'" :disabled="!file_selected" :loading="uploadattachment_loading"></action-button>
					</v-col>
				</template>
			</material-card>
		</ValidationObserver>
	</material-popup>
</template>

<script>
export default {
	data: () => ({
		single_attachment_edit: false,
		description: null,
		title: null,
		current_attachment_index: 1,
		selfloading: false,
		selfpreview_loading: false,
		loadPreviewTimeout: null,
		file_selected: false,
		extra_key_add: false,
		extra_key: null,
		extra_value: null,
		extra_info: {},
	}),
	props: {},
	computed: {
		canBeReaded() {
			if (this.attachmentCategory == "incomedeclarations") {
				return true;
			}
			return false;
		},
		showAttachmentProposedData: {
			get: function () {
				return this.$store.getters.showAttachmentProposedData;
			},
			set: function (value) {
				if (value == false) {
					this.$store.dispatch("hideAction", "hideAttachmentProposedData");
				}
			},
		},
		attachmentProposedData: {
			get: function () {
				return this.$store.getters.getAttachmentProposedData;
			},
			set: function (value) {
				this.$store.commit("setAttachmentProposedData", value);
			},
		},
		currentAttachment: {
			get: function () {
				return this.$store.getters.getCurrentAttachment;
			},
			set: function (value) {
				this.$store.commit("setCurrentAttachment", value);
			},
		},
		attachmentCategory() {
			return this.$store.getters.getAttachmentCategory;
		},
		currentDisplayAttachment() {
			if (this.currentAttachmentModel.id) {
				if (!_.isEmpty(this.currentAttachmentModel.attachments)) {
					return this.currentAttachmentModel.attachments[this.current_attachment_index - 1];
				}
			} else {
				if (!_.isEmpty(this.temporaryAttachment)) {
					let tempFormData = this.temporaryAttachment[this.current_attachment_index - 1];
					let responseFormData = {
						file: tempFormData.get("attachment"),
						title: tempFormData.get("title"),
						filename: tempFormData.get("filename"),
						description: tempFormData.get("description"),
					};
					responseFormData.filetype = responseFormData.file.type;
					responseFormData.filesize = responseFormData.file.size;
					if (window.webkitURL) {
						responseFormData.link = window.webkitURL.createObjectURL(new Blob([responseFormData.file]));
						responseFormData.thumbnail_link = responseFormData.link;
					} else if (window.URL && window.URL.createObjectURL) {
						responseFormData.link = window.URL.createObjectURL(new Blob([responseFormData.file]));
						responseFormData.thumbnail_link = responseFormData.link;
					}
					return responseFormData;
				}
			}
			return {};
		},
		attachment_loading() {
			return this.$store.getters.attachment_loading;
		},
		uploadattachment_loading() {
			return this.$store.getters.uploadattachment_loading;
		},
		apierrors() {
			return this.$store.getters.getApiErrors;
		},
		currentAttachmentModel: {
			get: function () {
				return this.$store.getters.getCurrentAttachmentModel;
			},
			set: function (value) {
				this.$store.commit("setCurrentAttachmentModel", value);
			},
		},
		showAttachment: {
			get: function () {
				return this.$store.getters.showAttachment;
			},
			set: function (value) {
				if (value == false) {
					this.$store.dispatch("hideAction", "hideAttachment");
				}
			},
		},
		readAttachmentInfoFromFile: {
			get: function () {
				return this.$store.getters.readAttachmentInfoFromFile;
			},
			set: function (value) {
				this.$store.commit("setReadAttachmentInfoFromFile", value);
			},
		},
		showAddAttachment: {
			get: function () {
				return this.$store.getters.showAddAttachment;
			},
			set: function (value) {
				if (value == false) {
					this.$store.dispatch("hideAction", "hideAddAttachment");
				}
			},
		},
		temporaryAttachment: {
			get: function () {
				return this.$store.getters.getTemporaryAttachment;
			},
			set: function (value) {
				this.$store.commit("setTemporaryAttachment", value);
			},
		},
		attachmentpreview_loading() {
			return this.$store.getters.attachmentpreview_loading;
		},
		extraInfoSize() {
			if (this.currentAttachment.id) {
				if (this.currentAttachment.extra_info) {
					if (Object.keys(this.currentAttachment.extra_info).length > 1) {
						return 6;
					}
				}
				return 12;
			}
			if (Object.keys(this.extra_info).length > 1) {
				return 6;
			}
			return 12;
		},
		tenant_config() {
			return this.$store.getters.getTenantConfig;
		},
	},
	methods: {
		loadAttachmentPreview() {
			const self = this;
			if (!self.selfpreview_loading) {
				if (self.currentDisplayAttachment.thumbnail_link) {
				} else {
					if (!self.attachmentpreview_loading && self.currentDisplayAttachment.id) {
						self.selfpreview_loading = true;
						self.$store.dispatch("loadAttachmentPreview", self.currentDisplayAttachment.id);
					}
					self.loadPreviewTimeout = setTimeout(function () {
						self.selfpreview_loading = false;
						self.loadAttachmentPreview();
					}, 5000);
				}
			}
		},
		closeAddAttachment() {
			if (this.currentAttachmentModel.id) {
				if (_.isEmpty(this.currentAttachmentModel.attachments)) {
					this.closeAttachment();
				}
			} else {
				if (_.isEmpty(this.temporaryAttachment)) {
					this.closeAttachment();
				}
			}
			this.showAddAttachment = false;
		},
		closeAttachment() {
			this.showAddAttachment = false;
			this.showAttachment = false;
		},
		addNewAttachment() {
			this.description = null;
			this.title = null;
			this.$store.dispatch("showAction", "showAddAttachment");
		},
		showUpdateAttachment() {
			this.currentAttachment = _.cloneDeep(this.currentDisplayAttachment);
			this.single_attachment_edit = true;
		},
		updateAttachmentProposedData() {
			if (this.attachmentProposedData.cert_expiration != undefined) {
				this.currentAttachment["extra_Data Scadenza"] = this.attachmentProposedData.cert_expiration;
			}
			if (this.attachmentProposedData.update_info != undefined) {
				this.currentAttachment.update_info = this.attachmentProposedData.update_info;
			}
			this.$store.dispatch("createAttachment").then((res) => {
				if (res.object) {
					this.showAttachmentProposedData = false;
					this.$store.dispatch("getAssociateDetails", this.currentAssociates.id);
					if (this.tenant_config.settings.AttachmentsViewStyle == "table") {
						this.$store.dispatch("hideAction", "hideAddAttachment");
						this.$store.dispatch("hideAction", "hideAttachment");
					}
				}
			});
		},
		updateAttachment() {
			const self = this;
			this.$refs.attachmentobserver.validate().then((isValid) => {
				if (isValid == true) {
					if (self.currentAttachmentModel.id) {
						self.$store.dispatch("createAttachment").then((res) => {
							if (res.object) {
								self.single_attachment_edit = false;
							}
						});
					} else {
						let cloned = self.temporaryAttachment[self.current_attachment_index - 1];
						if (self.currentAttachment.title) {
							cloned.set("title", self.currentAttachment.title);
						}
						if (self.currentAttachment.filename) {
							cloned.set("filename", self.currentAttachment.filename);
						}
						if (self.currentAttachment.description) {
							cloned.set("description", self.currentAttachment.description);
						}
						if (self.currentAttachment.extra_info) {
							cloned.set("extra_info", self.currentAttachment.extra_info);
						}
						self.temporaryAttachment[self.current_attachment_index - 1] = cloned;
						self.temporaryAttachment = _.cloneDeep(self.temporaryAttachment);
						self.single_attachment_edit = false;
					}
				}
			});
		},
		deleteAttachment() {
			const self = this;
			let message = self.$t("global.delete_confirm_message_pre");
			message += self.$t("attachment.question_selected");
			self.$store.commit("showDialog", {
				type: "confirm",
				title: self.$t("global.delete_confirm_title"),
				message: message,
				okCb: () => {
					if (self.currentAttachmentModel.id) {
						self.$store.dispatch("deleteAttachment", self.currentDisplayAttachment.id).then((res) => {
							if (res.object) {
								self.current_attachment_index = 1;
								if (_.isEmpty(self.currentAttachmentModel.attachments)) {
									self.closeAttachment();
								}
							}
						});
					} else {
						const self = this;
						self.temporaryAttachment.splice(self.current_attachment_index - 1, 1);
						self.current_attachment_index = 1;
						if (_.isEmpty(self.temporaryAttachment)) {
							self.closeAttachment();
						}
					}
				},
			});
		},
		storeTempForUpload(files) {
			this.formData = new FormData();
			this.formData.append("attachment", files[0]);
			this.file_selected = true;
		},
		uploadAttachment() {
			const self = this;
			if (this.description) {
				this.formData.append("description", this.description);
			}
			if (this.title) {
				this.formData.append("title", this.title);
			}
			if (this.extra_info) {
				Object.keys(this.extra_info).forEach((key) => {
					this.formData.append("extra_" + key, this.extra_info[key]);
				});
			}
			if (self.currentAttachmentModel.id) {
				self.$store.dispatch("uploadAttachment", self.formData).then((res) => {
					if (res.object) {
						self.showAddAttachment = false;
						self.current_attachment_index = self.currentAttachmentModel.attachments.length;
						self.file_selected = false;
						if (self.readAttachmentInfoFromFile) {
							self.currentAttachment = _.cloneDeep(self.currentDisplayAttachment);
							self.$store.dispatch("fetchAttachmentProposedData", res.object.id);
						}
					}
				});
			} else {
				self.formData.append("index", self.temporaryAttachment.length);
				self.temporaryAttachment.push(self.formData);
				self.showAddAttachment = false;
				self.file_selected = false;
				self.current_attachment_index = self.temporaryAttachment.length;
			}
		},
		downloadOrViewAttachment() {
			if (this.currentDisplayAttachment.link && params.action == "view") {
				this.$functions.openLink(this.currentDisplayAttachment.link);
			} else {
				this.$functions.openLink(this.currentDisplayAttachment.link, "download", this.currentDisplayAttachment.filename);
			}
		},
		addExtraKey() {
			this.extra_key = null;
			this.extra_value = null;
			this.extra_key_add = true;
		},
		addExtraInfoToCurrentAttachment() {
			if (!this.extra_key) {
				this.$store.commit("showSnackbar", {
					message: this.$t("attachment.extra_key_required"),
					color: "error",
					duration: 5000,
				});
				this.extra_key_add = true;
				return;
			}
			if (!this.extra_value) {
				this.$store.commit("showSnackbar", {
					message: this.$t("attachment.extra_key_required"),
					color: "error",
					duration: 5000,
				});
				this.extra_key_add = true;
				return;
			}
			if (this.currentAttachment.id) {
				this.currentAttachment.extra_info[this.extra_key.toLowerCase()] = this.extra_value;
				this.currentAttachment = _.cloneDeep(this.currentAttachment);
				this.updateAttachment();
			} else {
				this.extra_info[this.extra_key.toLowerCase()] = this.extra_value;
				this.extra_info = _.cloneDeep(this.extra_info);
			}

			this.extra_key = null;
			this.extra_value = null;
			this.extra_key_add = false;
		},
	},
	created() {
		this.current_attachment_index = 1;
		if (this.currentAttachmentModel.id) {
			if (_.isEmpty(this.currentAttachmentModel.attachments)) {
				this.addNewAttachment();
			} else {
				this.showAddAttachment = false;
			}
		} else {
			if (_.isEmpty(this.temporaryAttachment)) {
				this.addNewAttachment();
			} else {
				this.showAddAttachment = false;
			}
		}
		if (this.canBeReaded) {
			this.readAttachmentInfoFromFile = true;
		}
	},
	watch: {
		apierrors: {
			handler: function (val) {
				this.$functions.ApiErrorsWatcher(val, this.$refs.attachmentobserver);
			},
			deep: true,
		},
		currentAttachmentModel: {
			handler: function (val) {
				if (val.id) {
					if (_.isEmpty(val.attachments)) {
						this.addNewAttachment();
					}
				} else {
					if (_.isEmpty(this.temporaryAttachment)) {
						this.addNewAttachment();
					}
				}
			},
			deep: true,
		},
	},
	created() {
		if (this.currentAttachmentModel.id) {
			if (_.isEmpty(this.currentAttachmentModel.attachments)) {
				this.addNewAttachment();
			}
		} else {
			if (_.isEmpty(this.temporaryAttachment)) {
				this.addNewAttachment();
			}
		}
	},
	beforeDestroy() {
		clearTimeout(this.loadPreviewTimeout);
	},
};
</script>
